import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-placeholder",
  "use": "svg_i-placeholder-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg_i-placeholder\"><path d=\"M9.865 7.938 8.322 6.684a.622.622 0 0 0-.873 0l-.834.824a.622.622 0 0 1-.872 0l-.835-.824a.622.622 0 0 0-.872 0L2.493 7.938V2.614h7.372v5.324zM10.933.654H1.425a.912.912 0 0 0-.919.906v9.387c0 .5.412.906.919.906h9.508a.912.912 0 0 0 .918-.906V1.56c0-.5-.41-.906-.918-.906z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol